export default __webpack_public_path__ + "static/media/COLLISION-0.9467cfb7.svg";